/**
 * Artemis Application Server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * API Version: 10.6
 * Contact: krusche@tum.de
 *
 * NOTE: This file is auto-generated. Do not edit manually.
 */

/**
 * HyperionAuthoringRunApi - API service
 * @generated from OpenAPI specification
 */
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ExerciseGenerationStatus } from '../model/exercise-generation-status';
import { AuthoringRunPage } from '../model/authoring-run-page';
import { appendQueryParam } from './query-params';

@Injectable({ providedIn: 'root' })
export class HyperionAuthoringRunApi {
    private readonly http = inject(HttpClient);
    private readonly basePath = '';

    /**
     *
     *
     * @param requestBody
     */
    checkAuthoringRunAccess(requestBody: Array<string>): Observable<Array<string>> {
        const url = `${this.basePath}/api/hyperion/authoring-runs/access`;
        return this.http.post<Array<string>>(url, requestBody);
    }

    /**
     *
     *
     * @param exerciseId
     * @param runId
     */
    getAuthoringRunStatus(exerciseId: number, runId: string): Observable<ExerciseGenerationStatus> {
        const runIdPath = encodeURIComponent(String(runId));
        const url = `${this.basePath}/api/hyperion/programming-exercises/${exerciseId}/generation/runs/${runIdPath}`;
        return this.http.get<ExerciseGenerationStatus>(url);
    }

    /**
     *
     *
     * @param beforeId
     */
    getAuthoringRuns(beforeId?: number): Observable<AuthoringRunPage> {
        const queryParams = new URLSearchParams();
        appendQueryParam(queryParams, 'beforeId', beforeId);
        const queryString = queryParams.toString();
        const url = `${this.basePath}/api/hyperion/authoring-runs${queryString ? `?${queryString}` : ''}`;
        return this.http.get<AuthoringRunPage>(url);
    }

}
